module.exports = __webpack_public_path__ + "static/sanhitha-8c524fefc0df06c61e0d475f747f2e0c.jpg";